import switchToReadWriteRecipient from './switchToReadWriteRecipient';
import datapoints from '../datapoints';
import { ComposeViewState } from 'owa-mail-compose-store';
import createFromRecipientWell from '../utils/createFromRecipientWell';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { INVALID_SENDER_ERROR } from 'owa-mail-compose-actions/lib/utils/handleIsFromValid';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint(
    'toggleFrom',
    datapoints.ComposeCommandShowFrom
)(function toggleFrom(viewState: ComposeViewState) {
    viewState.fromViewState.isFromShown = !viewState.fromViewState.isFromShown;

    if (viewState.fromViewState.isFromShown && !viewState.fromViewState.from) {
        viewState.fromViewState.from = createFromRecipientWell(null, viewState.referenceItemId);
    }

    if (!viewState.fromViewState.isFromShown) {
        removeInfoBarMessage(viewState, INVALID_SENDER_ERROR);
    }

    // Readonly recipient well should be changed to readwrite recipient well when show from.
    if (viewState.fromViewState.isFromShown && viewState.showCompactRecipientWell) {
        switchToReadWriteRecipient(viewState);
    }
});
